import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionContainerComponent } from './accordion-container.component';
import { AccordionContentComponent } from './accordion-content.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    imports: [
        CommonModule,
        IconSharedModule
    ],
    declarations: [AccordionContainerComponent, AccordionContentComponent],
    exports: [AccordionContainerComponent, AccordionContentComponent]
})
export class AccordionContainerSharedModule {
}
